import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Button,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import AppointmentContext from '../../contexts/AppointmentContext';
import KlaraMeasssage from '../KlaraWidget';
import AreYouSureModal from '../../components/DialogModals/AreYouSureModal';
// import PaymentSuccessModal from '../PaymentSuccessModal';
import PatientInfoRow from './components/patientDashboard';
import * as authApi from '../../services/api/auth';
import {
  fetchPatientById,
  getGuardianDependentsDetails,
  deletePatientsAndAssociationsReq,
  fetchSubscriptedInfo,
  updatePatient,
  markReadStatusOnPatientNotification,
} from '../../services/api';
import './style.css';
// import { useSnackbar } from "notistack";

function PatientPortal(props) {
  const {
    history,
    classes: {
      expentionPanel,
      expentionPanelSummary,
      deleteButton,
      AccordionDetails,
      main,
      loadingCircle,
      expandMoreIcon,
    },
  } = props;
  // const { enqueueSnackbar } = useSnackbar();
  const [currentUser, setCurrentUser] = useState({});
  const [family, setFamily] = useState({});
  const [messageCount, setMessageCount] = useState(0);
  const [dependentToDeleteId, setDependentToDeleteId] = useState(null);
  const [providerInfo, setProviderInfo] = useState(null);
  const [isRead, setIsRead] = useState(null);
  const [subscribedDate, setSubscribedDate] = useState('');
  const [paymentMessage, setPaymentMessage] = useState(false);
  const [activeTab, setActivetab] = useState(false);
  const [buttonName, setButtonName] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const findLocation = useLocation();
  const findHistory = useHistory();

  useEffect(() => {
    (async () => {
      await patientsHandleFunction();
    })();
  }, []);

  const patientsHandleFunction = async () => {
    const { history } = props;
    try {
      const queryParams = new URLSearchParams(findLocation.search);
      if (queryParams.has('session_id')) {
        setPaymentMessage(true);
        // const queryString = queryParams.get('session_id');
        // const resultData = await adminApi.fetchSessionCheckout(queryString);
        // console.log('queryString', resultData);
        queryParams.delete('session_id');
        findHistory.replace({
          search: queryParams.toString(),
        });
      }
      const currUser = await authApi.fetchCurrentUser();
      setCurrentUser(currUser);
      const currPatient = await fetchPatientById(currUser.patient.id);
      setProviderInfo(currPatient);
      if (currPatient.isGuardian) {
        const dependents = await getGuardianDependentsDetails(currPatient.id);
        const subscribedInfo = await fetchSubscriptedInfo();
        setSubscribedDate(subscribedInfo);
        const familyObject = {
          [currPatient.id]: currPatient,
        };
        familyObject[currPatient.id].expanded = false;
        dependents.forEach(dependent => {
          familyObject[dependent.id] = dependent;
          /**
           * added expanded key in familyObject for open expansionDetails
           */
          familyObject[dependent.id].expanded = false;
        });
        setFamily(familyObject);
        setIsLoading(true);
      } else {
        const currentObject = {
          [currPatient.id]: currPatient,
        };
        /**
         * added expanded key in familyObject for open expansionDetails
         */
        currentObject[currPatient.id].expanded = false;
        setFamily(currentObject);
        setIsLoading(true);
      }
    } catch (err) {
      props.enqueueSnackbar(
        'There was a problem finding your account, please login again.',
        {
          preventDuplicate: true,
          autoHideDuration: 3000,
        }
      );
      history.push('/login');
    }
  };

  /**
   *
   * @param {*} params
   * type : message || appointment_Request have two enum
   * @param {*} type = 'appointment_Request'
   */
  const markReadStatus = async (params, type = 'appointment_Request') => {
    try {
      const markReadNotification = await markReadStatusOnPatientNotification(
        params,
        type
      );
      setIsRead(markReadNotification && markReadNotification);
    } catch (error) {
      props.enqueueSnackbar('Oops, something went wrong. Please Try again', {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    }
  };

  const onUpdatePatient = async patient => {
    try {
      const currPatient = await updatePatient(patient);
      // const currentObject = {
      //   [patient.id]: currPatient,
      // };
      // currentObject[patient.id].expanded = false;
      setFamily({
        ...family,
        [patient.id]: currPatient,
      });
      props.enqueueSnackbar('Profile updated!', {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    } catch {
      props.enqueueSnackbar('Oops, something went wrong. Please Try again', {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    }
  };

  /**
   * Delete Dependent function
   */
  const onDeleteDependent = async patientId => {
    await deletePatientsAndAssociationsReq([patientId]);
    delete family[patientId];
    setFamily(family);
  };

  /**
   * Book appointment function
   */
  const handleBookAppointment = (e, patientId) => {
    e.stopPropagation();
    // let returnUrl = 'http:/localhost:3008';
    // window.location.assign(`${returnUrl + '/?patientId=' + patientId}`);
    window.location.assign(
      `${process.env.REACT_APP_HOMEPAGE_URL + '/?patientId=' + patientId}`
    );
  };

  /**
   * open upcoming Appt function
   */
  const handleViewUpcomingAppt = (e, patientId) => {
    e.stopPropagation();
    handleExpand(e, patientId, 'clickUpcomingApptButton');
  };

  /**
   * open View Profile fub=ction
   */
  const handleViewProfile = (e, patientId) => {
    e.stopPropagation();
    handleExpand(e, patientId, 'clickViewProfileButton');
  };

  /**
   * open Appointment Request function
   */
  const handleApptRequest = (e, patientId, ids) => {
    e.stopPropagation();
    handleExpand(e, patientId, 'clickApptRequestButton', ids);
  };

  /**
   * expand the patient Details function
   */
  const handleExpand = (e, patientId, string, ids = false) => {
    e.stopPropagation();
    if (string === 'clickUpcomingApptButton') {
      Object.keys(family).map(key => {
        if (patientId == key) {
          family[patientId].expanded = true;
          setActivetab(true);
          setButtonName('clickUpcomingApptButton');
        }
        //  else {
        //   family[key].expanded = false;
        // }
      });
      setFamily(JSON.parse(JSON.stringify(family)));
    } else if (string === 'clickApptRequestButton') {
      Object.keys(family).map(async key => {
        if (patientId == key) {
          family[patientId].expanded = true;
          if (Array.isArray(ids)) {
            markReadStatus(ids);
          }
          setActivetab(true);
          setButtonName('clickApptRequestButton');
        }
      });
      setFamily(JSON.parse(JSON.stringify(family)));
    } else if (string === 'clickViewProfileButton') {
      Object.keys(family).map(key => {
        if (patientId == key) {
          family[patientId].expanded = true;
        }
      });
      setFamily(JSON.parse(JSON.stringify(family)));
    } else {
      Object.keys(family).map(key => {
        if (patientId == key) {
          family[patientId].expanded = !family[patientId].expanded;
        } else {
          family[key].expanded = false;
        }
      });
      setFamily(JSON.parse(JSON.stringify(family)));
    }
  };

  return isLoading ? (
    Object.keys(family).map((patientId, i) => {
      const patient = family[patientId];
      const { apptRequestCount, ids } = family[patientId].patientNotification;
      return (
        <>
          <div className={main}>
            <Accordion
              // key={patient.id}
              expanded={family[patientId].expanded}
              className={expentionPanel}
            >
              <AccordionSummary
                className={expentionPanelSummary}
                onClick={event => handleExpand(event, patientId)}
              >
                <div className="expentionPanelSummaryLeft">
                  <h1 className="headFont">
                    {patient.firstName + ' ' + patient.lastName}{' '}
                    {family[patientId].expanded && (
                      <ExpandMoreIcon className={expandMoreIcon} />
                    )}
                  </h1>
                  <Button
                    className="profile-btn-sm"
                    size="small"
                    onClick={event => handleViewProfile(event, patientId)}
                  >
                    {' '}
                    My Profile
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={event => handleViewUpcomingAppt(event, patientId)}
                  >
                    {' '}
                    Upcoming Appointments
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={event => handleBookAppointment(event, patientId)}
                  >
                    {' '}
                    Book Appointment
                  </Button>
                  {isRead == 'Patient readed the message' ? (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={event => handleApptRequest(event, patientId)}
                    >
                      {' '}
                      Appointment Request
                    </Button>
                  ) : apptRequestCount > 0 ? (
                    <Badge
                      badgeContent={apptRequestCount}
                      color="primary"
                      className="update-badge"
                    >
                      <Button
                        variant="contained"
                        size="small"
                        onClick={event =>
                          handleApptRequest(event, patientId, ids)
                        }
                      >
                        {' '}
                        Appointment Request
                      </Button>
                    </Badge>
                  ) : (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={event => handleApptRequest(event, patientId)}
                    >
                      {' '}
                      Appointment Request
                    </Button>
                  )}
                </div>
                {!patient.isGuardian && Object.keys(family).length > 1 && (
                  <div className="marginLeft">
                    <Button
                      onClick={event => {
                        event.stopPropagation();
                        setDependentToDeleteId(patient.id);
                      }}
                      color="#0277bd"
                      variant="contained"
                      className={deleteButton}
                      size="small"
                    >
                      {' '}
                      remove
                    </Button>
                  </div>
                )}
              </AccordionSummary>
              <div className="zeroPad">
                <AccordionDetails className={AccordionDetails}>
                  {family[patientId].expanded == true ? (
                    <PatientInfoRow
                      key={i}
                      patient={patient}
                      history={history}
                      currentUserInfo={currentUser}
                      onUpdatePatient={onUpdatePatient}
                      activeTab={activeTab}
                      setActivetab={setActivetab}
                      setButtonName={setButtonName}
                      buttonName={buttonName}
                      markReadStatus={markReadStatus}
                      // setFamily={family}
                    />
                  ) : null}
                </AccordionDetails>
              </div>
            </Accordion>
          </div>
          <KlaraMeasssage />
          <AreYouSureModal
            open={dependentToDeleteId === patient.id}
            message="Patient data will be lost"
            confirmButtonTag="REMOVE"
            executMethod={async () => {
              await onDeleteDependent(dependentToDeleteId);
              setDependentToDeleteId(null);
            }}
            onClose={() => setDependentToDeleteId(null)}
          />
        </>
      );
    })
  ) : (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      spacing={2}
      className={loadingCircle}
    >
      <CircularProgress size={60} />
    </Grid>
  );
}

const styles = theme => ({
  expentionPanel: {
    // width: '60%',
    // margin: '15px auto 15px auto',
    marginTop: '7px',
    marginBottom: '7px',
    backgroundColor: '#F2F5F7',
  },
  expentionPanelSummary: {
    overflowX: 'visible',
    fontSize: '13px',
    borderRadius: '5px',
    color: 'white',
    backgroundColor: '#6193C5',
  },
  deleteButton: {
    marginLeft: '50%',
  },
  AccordionDetails: {},
  expandMoreIcon: {
    margin: 'auto auto auto 10px',
    // border:'solid 1px red',
    fontSize: '35px',
    position: 'absolute',
  },
  main: {
    margin: '35px',
    // border:'solid 1px red',
  },
  loadingCircle: {
    minHeight: '600px',
  },
});

PatientPortal.contextType = AppointmentContext;
export default withSnackbar(withStyles(styles)(PatientPortal));
